__turbopack_context__.v({
  "article": "article-blocks-module__jYPBKW__article",
  "articleContent": "article-blocks-module__jYPBKW__articleContent",
  "body": "article-blocks-module__jYPBKW__body",
  "card": "article-blocks-module__jYPBKW__card",
  "cardCopy": "article-blocks-module__jYPBKW__cardCopy",
  "cardDate": "article-blocks-module__jYPBKW__cardDate",
  "cardImage": "article-blocks-module__jYPBKW__cardImage",
  "cardLink": "article-blocks-module__jYPBKW__cardLink",
  "cardTitle": "article-blocks-module__jYPBKW__cardTitle",
  "excerpt": "article-blocks-module__jYPBKW__excerpt",
  "featuredImage": "article-blocks-module__jYPBKW__featuredImage",
  "grid": "article-blocks-module__jYPBKW__grid",
  "metadata": "article-blocks-module__jYPBKW__metadata",
  "pagination": "article-blocks-module__jYPBKW__pagination",
  "posts": "article-blocks-module__jYPBKW__posts",
  "postsContent": "article-blocks-module__jYPBKW__postsContent",
  "readingTime": "article-blocks-module__jYPBKW__readingTime",
  "share": "article-blocks-module__jYPBKW__share",
});
